const QRCodePopupModule = {
  namespaced: true,
  state: {
    isShowQR: false
  },
  mutations: {
    SET_SHOW_QR (state, data) {
      state.isShowQR = data
    }
  },
  actions: {
    setShowQR({ commit }, payload) {
      commit('SET_SHOW_QR', payload)
    }
  },
  getters: {
    isShowQR (state) {
      return state.isShowQR
    }
  }
}

export default QRCodePopupModule
